import { render, staticRenderFns } from "./AssetItemFieldLabel.vue?vue&type=template&id=09e38675&scoped=true&"
import script from "./AssetItemFieldLabel.vue?vue&type=script&lang=js&"
export * from "./AssetItemFieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e38675",
  null
  
)

export default component.exports